import React, { useState } from 'react';
import { User, Mail, Phone, Calendar, MapPin, Briefcase, FileText, Star, Clock, Check, X, Send, Search, Filter, ChevronDown, ChevronRight, AlertCircle } from 'lucide-react';
// Sample candidate data
const sampleCandidates = [{
  id: 1,
  name: 'Jennifer Wilson',
  email: 'jennifer.wilson@example.com',
  phone: '+1 (555) 123-4567',
  location: 'New York, NY',
  position: 'Senior Frontend Developer',
  appliedDate: '2023-05-15',
  status: 'New',
  experience: '8 years',
  skills: ['React', 'TypeScript', 'Node.js', 'GraphQL', 'AWS'],
  education: 'MS Computer Science, Stanford University',
  resumeUrl: 'https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf',
  photo: 'https://randomuser.me/api/portraits/women/44.jpg',
  summary: 'Experienced frontend developer with a strong background in React and TypeScript. Passionate about creating intuitive user experiences and optimizing application performance.',
  interviews: [{
    date: '2023-05-20',
    type: 'Phone Screening',
    feedback: 'Great communication skills, technical knowledge seems solid.'
  }, {
    date: '2023-05-25',
    type: 'Technical Interview',
    feedback: 'Excellent problem-solving abilities. Demonstrated deep knowledge of React ecosystem.'
  }]
}, {
  id: 2,
  name: 'Michael Chen',
  email: 'michael.chen@example.com',
  phone: '+1 (555) 987-6543',
  location: 'San Francisco, CA',
  position: 'Full Stack Developer',
  appliedDate: '2023-05-10',
  status: 'Shortlisted',
  experience: '5 years',
  skills: ['JavaScript', 'React', 'Python', 'Django', 'Docker'],
  education: 'BS Computer Engineering, UC Berkeley',
  resumeUrl: 'https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf',
  photo: 'https://randomuser.me/api/portraits/men/32.jpg',
  summary: 'Full stack developer with experience in both frontend and backend technologies. Specializes in building scalable web applications with React and Django.',
  interviews: [{
    date: '2023-05-18',
    type: 'Phone Screening',
    feedback: 'Good technical background, enthusiastic about the role.'
  }]
}, {
  id: 3,
  name: 'Sarah Johnson',
  email: 'sarah.johnson@example.com',
  phone: '+1 (555) 234-5678',
  location: 'Chicago, IL',
  position: 'UI/UX Designer',
  appliedDate: '2023-05-08',
  status: 'In Review',
  experience: '4 years',
  skills: ['Figma', 'Adobe XD', 'Sketch', 'HTML/CSS', 'User Research'],
  education: 'BFA Design, Rhode Island School of Design',
  resumeUrl: 'https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf',
  photo: 'https://randomuser.me/api/portraits/women/68.jpg',
  summary: 'Creative UI/UX designer with a focus on user-centered design principles. Experienced in creating wireframes, prototypes, and high-fidelity designs.',
  interviews: []
}, {
  id: 4,
  name: 'David Kim',
  email: 'david.kim@example.com',
  phone: '+1 (555) 876-5432',
  location: 'Seattle, WA',
  position: 'DevOps Engineer',
  appliedDate: '2023-05-05',
  status: 'KIV',
  experience: '6 years',
  skills: ['Kubernetes', 'AWS', 'Terraform', 'CI/CD', 'Docker'],
  education: 'BS Computer Science, University of Washington',
  resumeUrl: 'https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf',
  photo: 'https://randomuser.me/api/portraits/men/75.jpg',
  summary: 'DevOps engineer specializing in cloud infrastructure and automation. Experienced in implementing CI/CD pipelines and managing containerized applications.',
  interviews: [{
    date: '2023-05-12',
    type: 'Phone Screening',
    feedback: 'Strong technical background but might be overqualified for the position.'
  }]
}, {
  id: 5,
  name: 'Emily Rodriguez',
  email: 'emily.rodriguez@example.com',
  phone: '+1 (555) 345-6789',
  location: 'Austin, TX',
  position: 'Product Manager',
  appliedDate: '2023-05-03',
  status: 'Rejected',
  experience: '7 years',
  skills: ['Product Strategy', 'Agile', 'User Stories', 'Market Research', 'Data Analysis'],
  education: 'MBA, University of Texas at Austin',
  resumeUrl: 'https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf',
  photo: 'https://randomuser.me/api/portraits/women/90.jpg',
  summary: 'Product manager with experience in leading cross-functional teams and delivering successful products. Strong background in agile methodologies and user-centered design.',
  interviews: [{
    date: '2023-05-10',
    type: 'Phone Screening',
    feedback: 'Good experience but not aligned with our current product direction.'
  }]
}, {
  id: 6,
  name: 'Robert Taylor',
  email: 'robert.taylor@example.com',
  phone: '+1 (555) 456-7890',
  location: 'Boston, MA',
  position: 'Data Scientist',
  appliedDate: '2023-05-01',
  status: 'Accepted',
  experience: '3 years',
  skills: ['Python', 'Machine Learning', 'SQL', 'TensorFlow', 'Data Visualization'],
  education: 'PhD Statistics, MIT',
  resumeUrl: 'https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf',
  photo: 'https://randomuser.me/api/portraits/men/22.jpg',
  summary: 'Data scientist with a strong mathematical background and experience in machine learning and statistical analysis. Passionate about using data to drive business decisions.',
  interviews: [{
    date: '2023-05-08',
    type: 'Phone Screening',
    feedback: 'Excellent technical skills and communication.'
  }, {
    date: '2023-05-15',
    type: 'Technical Interview',
    feedback: 'Outstanding problem-solving abilities and deep knowledge of ML algorithms.'
  }, {
    date: '2023-05-22',
    type: 'Final Interview',
    feedback: 'Great cultural fit. Recommended for hire.'
  }]
}];
const translations = {
  en: {
    candidates: 'Candidates',
    search: 'Search candidates...',
    filter: 'Filter',
    all: 'All',
    new: 'New',
    shortlisted: 'Shortlisted',
    inReview: 'In Review',
    kiv: 'KIV',
    rejected: 'Rejected',
    accepted: 'Accepted',
    candidateDetails: 'Candidate Details',
    resume: 'Resume',
    contactInfo: 'Contact Information',
    email: 'Email',
    phone: 'Phone',
    location: 'Location',
    appliedFor: 'Applied for',
    appliedOn: 'Applied on',
    experience: 'Experience',
    education: 'Education',
    skills: 'Skills',
    interviews: 'Interview History',
    noInterviews: 'No interviews scheduled yet',
    actions: 'Actions',
    shortlist: 'Shortlist',
    keepInView: 'Keep in View',
    reject: 'Reject',
    accept: 'Accept',
    sendEmail: 'Send Email',
    subject: 'Subject',
    message: 'Message',
    send: 'Send',
    cancel: 'Cancel',
    emailSent: 'Email sent successfully!',
    statusUpdated: 'Candidate status updated!',
    date: 'Date',
    type: 'Type',
    feedback: 'Feedback',
    noCandidate: 'Select a candidate to view details',
    candidateCount: 'candidates',
    summary: 'Summary'
  },
  de: {
    candidates: 'Kandidaten',
    search: 'Kandidaten suchen...',
    filter: 'Filter',
    all: 'Alle',
    new: 'Neu',
    shortlisted: 'Vorausgewählt',
    inReview: 'In Prüfung',
    kiv: 'Im Auge behalten',
    rejected: 'Abgelehnt',
    accepted: 'Akzeptiert',
    candidateDetails: 'Kandidatendetails',
    resume: 'Lebenslauf',
    contactInfo: 'Kontaktinformationen',
    email: 'E-Mail',
    phone: 'Telefon',
    location: 'Standort',
    appliedFor: 'Beworben für',
    appliedOn: 'Beworben am',
    experience: 'Erfahrung',
    education: 'Ausbildung',
    skills: 'Fähigkeiten',
    interviews: 'Gesprächsverlauf',
    noInterviews: 'Noch keine Gespräche geplant',
    actions: 'Aktionen',
    shortlist: 'Vorauswahl',
    keepInView: 'Im Auge behalten',
    reject: 'Ablehnen',
    accept: 'Akzeptieren',
    sendEmail: 'E-Mail senden',
    subject: 'Betreff',
    message: 'Nachricht',
    send: 'Senden',
    cancel: 'Abbrechen',
    emailSent: 'E-Mail erfolgreich gesendet!',
    statusUpdated: 'Kandidatenstatus aktualisiert!',
    date: 'Datum',
    type: 'Typ',
    feedback: 'Feedback',
    noCandidate: 'Wählen Sie einen Kandidaten, um Details anzuzeigen',
    candidateCount: 'Kandidaten',
    summary: 'Zusammenfassung'
  },
  fr: {
    candidates: 'Candidats',
    search: 'Rechercher des candidats...',
    filter: 'Filtrer',
    all: 'Tous',
    new: 'Nouveau',
    shortlisted: 'Présélectionné',
    inReview: 'En examen',
    kiv: 'À surveiller',
    rejected: 'Rejeté',
    accepted: 'Accepté',
    candidateDetails: 'Détails du candidat',
    resume: 'CV',
    contactInfo: 'Coordonnées',
    email: 'Email',
    phone: 'Téléphone',
    location: 'Lieu',
    appliedFor: 'Postulé pour',
    appliedOn: 'Postulé le',
    experience: 'Expérience',
    education: 'Formation',
    skills: 'Compétences',
    interviews: 'Historique des entretiens',
    noInterviews: 'Aucun entretien planifié pour le moment',
    actions: 'Actions',
    shortlist: 'Présélectionner',
    keepInView: "Garder à l'esprit",
    reject: 'Rejeter',
    accept: 'Accepter',
    sendEmail: 'Envoyer un email',
    subject: 'Sujet',
    message: 'Message',
    send: 'Envoyer',
    cancel: 'Annuler',
    emailSent: 'Email envoyé avec succès!',
    statusUpdated: 'Statut du candidat mis à jour!',
    date: 'Date',
    type: 'Type',
    feedback: 'Commentaires',
    noCandidate: 'Sélectionnez un candidat pour voir les détails',
    candidateCount: 'candidats',
    summary: 'Résumé'
  },
  it: {
    candidates: 'Candidati',
    search: 'Cerca candidati...',
    filter: 'Filtra',
    all: 'Tutti',
    new: 'Nuovo',
    shortlisted: 'Preselezionato',
    inReview: 'In revisione',
    kiv: 'Da tenere in considerazione',
    rejected: 'Rifiutato',
    accepted: 'Accettato',
    candidateDetails: 'Dettagli candidato',
    resume: 'Curriculum',
    contactInfo: 'Informazioni di contatto',
    email: 'Email',
    phone: 'Telefono',
    location: 'Località',
    appliedFor: 'Candidato per',
    appliedOn: 'Candidato il',
    experience: 'Esperienza',
    education: 'Istruzione',
    skills: 'Competenze',
    interviews: 'Storico colloqui',
    noInterviews: 'Nessun colloquio programmato',
    actions: 'Azioni',
    shortlist: 'Preseleziona',
    keepInView: 'Tieni in considerazione',
    reject: 'Rifiuta',
    accept: 'Accetta',
    sendEmail: 'Invia email',
    subject: 'Oggetto',
    message: 'Messaggio',
    send: 'Invia',
    cancel: 'Annulla',
    emailSent: 'Email inviata con successo!',
    statusUpdated: 'Stato del candidato aggiornato!',
    date: 'Data',
    type: 'Tipo',
    feedback: 'Feedback',
    noCandidate: 'Seleziona un candidato per visualizzare i dettagli',
    candidateCount: 'candidati',
    summary: 'Riepilogo'
  }
};
const statusColors = {
  New: 'bg-blue-100 text-blue-800',
  Shortlisted: 'bg-purple-100 text-purple-800',
  'In Review': 'bg-yellow-100 text-yellow-800',
  KIV: 'bg-orange-100 text-orange-800',
  Rejected: 'bg-red-100 text-red-800',
  Accepted: 'bg-green-100 text-green-800'
};
export function CandidateSection({
  language
}) {
  const t = translations[language];
  const [candidates, setCandidates] = useState(sampleCandidates);
  const [selectedCandidate, setSelectedCandidate] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [statusFilter, setStatusFilter] = useState('All');
  const [showEmailModal, setShowEmailModal] = useState(false);
  const [emailSubject, setEmailSubject] = useState('');
  const [emailMessage, setEmailMessage] = useState('');
  const [notification, setNotification] = useState(null);
  // Filter candidates based on search term and status filter
  const filteredCandidates = candidates.filter(candidate => {
    const matchesSearch = candidate.name.toLowerCase().includes(searchTerm.toLowerCase()) || candidate.position.toLowerCase().includes(searchTerm.toLowerCase()) || candidate.email.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesStatus = statusFilter === 'All' || candidate.status === statusFilter;
    return matchesSearch && matchesStatus;
  });
  // Update candidate status
  const updateCandidateStatus = (id, newStatus) => {
    setCandidates(candidates.map(candidate => candidate.id === id ? {
      ...candidate,
      status: newStatus
    } : candidate));
    // Show notification
    setNotification({
      message: t.statusUpdated,
      type: 'success'
    });
    // Hide notification after 3 seconds
    setTimeout(() => {
      setNotification(null);
    }, 3000);
  };
  // Send email to candidate
  const sendEmail = () => {
    // In a real application, this would send an email to the candidate
    console.log('Sending email to', selectedCandidate.email);
    console.log('Subject:', emailSubject);
    console.log('Message:', emailMessage);
    // Close modal and reset fields
    setShowEmailModal(false);
    setEmailSubject('');
    setEmailMessage('');
    // Show notification
    setNotification({
      message: t.emailSent,
      type: 'success'
    });
    // Hide notification after 3 seconds
    setTimeout(() => {
      setNotification(null);
    }, 3000);
  };
  // Format date
  const formatDate = dateString => {
    const options = {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };
  return <div className="container mx-auto px-4 py-6" data-id="element-12">
      <div className="bg-white rounded-lg shadow-lg overflow-hidden" data-id="element-13">
        <div className="flex flex-col md:flex-row h-[calc(100vh-200px)]" data-id="element-14">
          {/* Candidate List */}
          <div className="w-full md:w-1/3 border-r border-gray-200 overflow-hidden flex flex-col" data-id="element-15">
            <div className="p-4 border-b border-gray-200" data-id="element-16">
              <h2 className="text-xl font-bold text-gray-800" data-id="element-17">
                {t.candidates}
              </h2>
              <div className="mt-2 relative" data-id="element-18">
                <input type="text" placeholder={t.search} className="w-full border border-gray-300 rounded-md py-2 px-4 pl-10 focus:outline-none focus:ring-2 focus:ring-blue-500" value={searchTerm} onChange={e => setSearchTerm(e.target.value)} data-id="element-19" />
                <Search className="absolute left-3 top-2.5 text-gray-400" size={18} data-id="element-20" />
              </div>
              <div className="mt-3 flex items-center" data-id="element-21">
                <Filter size={16} className="text-gray-500 mr-2" data-id="element-22" />
                <span className="text-sm text-gray-500 mr-2" data-id="element-23">{t.filter}:</span>
                <div className="relative inline-block text-left" data-id="element-24">
                  <select className="appearance-none bg-white border border-gray-300 rounded-md py-1 px-3 pr-8 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500" value={statusFilter} onChange={e => setStatusFilter(e.target.value)} data-id="element-25">
                    <option value="All" data-id="element-26">{t.all}</option>
                    <option value="New" data-id="element-27">{t.new}</option>
                    <option value="Shortlisted" data-id="element-28">{t.shortlisted}</option>
                    <option value="In Review" data-id="element-29">{t.inReview}</option>
                    <option value="KIV" data-id="element-30">{t.kiv}</option>
                    <option value="Rejected" data-id="element-31">{t.rejected}</option>
                    <option value="Accepted" data-id="element-32">{t.accepted}</option>
                  </select>
                  <ChevronDown size={14} className="absolute right-2 top-2 text-gray-500 pointer-events-none" data-id="element-33" />
                </div>
                <span className="ml-3 text-sm text-gray-500" data-id="element-34">
                  {filteredCandidates.length} {t.candidateCount}
                </span>
              </div>
            </div>
            <div className="overflow-y-auto flex-grow" data-id="element-35">
              {filteredCandidates.map(candidate => <div key={candidate.id} className={`p-4 border-b border-gray-200 hover:bg-gray-50 cursor-pointer ${selectedCandidate && selectedCandidate.id === candidate.id ? 'bg-blue-50' : ''}`} onClick={() => setSelectedCandidate(candidate)} data-id="element-36">
                  <div className="flex items-center" data-id="element-37">
                    <img src={candidate.photo} alt={candidate.name} className="w-10 h-10 rounded-full mr-3" data-id="element-38" />
                    <div className="flex-grow" data-id="element-39">
                      <h3 className="font-medium text-gray-900" data-id="element-40">
                        {candidate.name}
                      </h3>
                      <p className="text-sm text-gray-500" data-id="element-41">
                        {candidate.position}
                      </p>
                    </div>
                    <div data-id="element-42">
                      <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${statusColors[candidate.status]}`} data-id="element-43">
                        {candidate.status === 'New' && t.new}
                        {candidate.status === 'Shortlisted' && t.shortlisted}
                        {candidate.status === 'In Review' && t.inReview}
                        {candidate.status === 'KIV' && t.kiv}
                        {candidate.status === 'Rejected' && t.rejected}
                        {candidate.status === 'Accepted' && t.accepted}
                      </span>
                    </div>
                  </div>
                  <div className="mt-2 flex items-center text-xs text-gray-500" data-id="element-44">
                    <Calendar size={12} className="mr-1" data-id="element-45" />
                    <span data-id="element-46">{formatDate(candidate.appliedDate)}</span>
                    <span className="mx-2" data-id="element-47">•</span>
                    <Mail size={12} className="mr-1" data-id="element-48" />
                    <span data-id="element-49">{candidate.email}</span>
                  </div>
                </div>)}
            </div>
          </div>
          {/* Candidate Details */}
          <div className="w-full md:w-2/3 overflow-y-auto" data-id="element-50">
            {selectedCandidate ? <div className="p-6" data-id="element-51">
                <div className="flex flex-col md:flex-row md:items-center justify-between" data-id="element-52">
                  <div className="flex items-center" data-id="element-53">
                    <img src={selectedCandidate.photo} alt={selectedCandidate.name} className="w-16 h-16 rounded-full mr-4" data-id="element-54" />
                    <div data-id="element-55">
                      <h2 className="text-2xl font-bold text-gray-900" data-id="element-56">
                        {selectedCandidate.name}
                      </h2>
                      <p className="text-gray-600" data-id="element-57">
                        {selectedCandidate.position}
                      </p>
                      <span className={`mt-1 inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${statusColors[selectedCandidate.status]}`} data-id="element-58">
                        {selectedCandidate.status === 'New' && t.new}
                        {selectedCandidate.status === 'Shortlisted' && t.shortlisted}
                        {selectedCandidate.status === 'In Review' && t.inReview}
                        {selectedCandidate.status === 'KIV' && t.kiv}
                        {selectedCandidate.status === 'Rejected' && t.rejected}
                        {selectedCandidate.status === 'Accepted' && t.accepted}
                      </span>
                    </div>
                  </div>
                  <div className="mt-4 md:mt-0" data-id="element-59">
                    <a href={selectedCandidate.resumeUrl} target="_blank" rel="noopener noreferrer" className="inline-flex items-center px-4 py-2 border border-blue-600 rounded-md shadow-sm text-sm font-medium text-blue-600 bg-white hover:bg-blue-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500" data-id="element-60">
                      <FileText size={16} className="mr-2" data-id="element-61" />
                      {t.resume}
                    </a>
                  </div>
                </div>
                <div className="mt-6" data-id="element-62">
                  <h3 className="text-lg font-medium text-gray-900" data-id="element-63">
                    {t.summary}
                  </h3>
                  <p className="mt-2 text-gray-600" data-id="element-64">
                    {selectedCandidate.summary}
                  </p>
                </div>
                <div className="mt-6" data-id="element-65">
                  <h3 className="text-lg font-medium text-gray-900" data-id="element-66">
                    {t.contactInfo}
                  </h3>
                  <div className="mt-2 grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-67">
                    <div className="flex items-center" data-id="element-68">
                      <Mail size={16} className="text-gray-400 mr-2" data-id="element-69" />
                      <span className="text-gray-600" data-id="element-70">
                        {selectedCandidate.email}
                      </span>
                    </div>
                    <div className="flex items-center" data-id="element-71">
                      <Phone size={16} className="text-gray-400 mr-2" data-id="element-72" />
                      <span className="text-gray-600" data-id="element-73">
                        {selectedCandidate.phone}
                      </span>
                    </div>
                    <div className="flex items-center" data-id="element-74">
                      <MapPin size={16} className="text-gray-400 mr-2" data-id="element-75" />
                      <span className="text-gray-600" data-id="element-76">
                        {selectedCandidate.location}
                      </span>
                    </div>
                    <div className="flex items-center" data-id="element-77">
                      <Calendar size={16} className="text-gray-400 mr-2" data-id="element-78" />
                      <span className="text-gray-600" data-id="element-79">
                        {t.appliedOn}:{' '}
                        {formatDate(selectedCandidate.appliedDate)}
                      </span>
                    </div>
                  </div>
                </div>
                <div className="mt-6" data-id="element-80">
                  <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-81">
                    <div data-id="element-82">
                      <h3 className="text-lg font-medium text-gray-900" data-id="element-83">
                        {t.experience}
                      </h3>
                      <div className="mt-2 flex items-center" data-id="element-84">
                        <Briefcase size={16} className="text-gray-400 mr-2" data-id="element-85" />
                        <span className="text-gray-600" data-id="element-86">
                          {selectedCandidate.experience}
                        </span>
                      </div>
                    </div>
                    <div data-id="element-87">
                      <h3 className="text-lg font-medium text-gray-900" data-id="element-88">
                        {t.education}
                      </h3>
                      <div className="mt-2 flex items-center" data-id="element-89">
                        <FileText size={16} className="text-gray-400 mr-2" data-id="element-90" />
                        <span className="text-gray-600" data-id="element-91">
                          {selectedCandidate.education}
                        </span>
                      </div>
                    </div>
                    <div data-id="element-92">
                      <h3 className="text-lg font-medium text-gray-900" data-id="element-93">
                        {t.skills}
                      </h3>
                      <div className="mt-2 flex flex-wrap gap-2" data-id="element-94">
                        {selectedCandidate.skills.map((skill, index) => <span key={index} className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-800" data-id="element-95">
                            {skill}
                          </span>)}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="mt-6" data-id="element-96">
                  <h3 className="text-lg font-medium text-gray-900" data-id="element-97">
                    {t.interviews}
                  </h3>
                  {selectedCandidate.interviews.length > 0 ? <div className="mt-2 overflow-hidden shadow ring-1 ring-black ring-opacity-5 md:rounded-lg" data-id="element-98">
                      <table className="min-w-full divide-y divide-gray-300" data-id="element-99">
                        <thead className="bg-gray-50" data-id="element-100">
                          <tr data-id="element-101">
                            <th className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6" data-id="element-102">
                              {t.date}
                            </th>
                            <th className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900" data-id="element-103">
                              {t.type}
                            </th>
                            <th className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900" data-id="element-104">
                              {t.feedback}
                            </th>
                          </tr>
                        </thead>
                        <tbody className="divide-y divide-gray-200 bg-white" data-id="element-105">
                          {selectedCandidate.interviews.map((interview, index) => <tr key={index} data-id="element-106">
                                <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm text-gray-500 sm:pl-6" data-id="element-107">
                                  {formatDate(interview.date)}
                                </td>
                                <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500" data-id="element-108">
                                  {interview.type}
                                </td>
                                <td className="px-3 py-4 text-sm text-gray-500" data-id="element-109">
                                  {interview.feedback}
                                </td>
                              </tr>)}
                        </tbody>
                      </table>
                    </div> : <p className="mt-2 text-gray-500" data-id="element-110">{t.noInterviews}</p>}
                </div>
                <div className="mt-8 border-t border-gray-200 pt-6" data-id="element-111">
                  <h3 className="text-lg font-medium text-gray-900" data-id="element-112">
                    {t.actions}
                  </h3>
                  <div className="mt-2 flex flex-wrap gap-3" data-id="element-113">
                    <button className="inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-purple-600 hover:bg-purple-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-purple-500" onClick={() => updateCandidateStatus(selectedCandidate.id, 'Shortlisted')} data-id="element-114">
                      <Star size={16} className="mr-2" data-id="element-115" />
                      {t.shortlist}
                    </button>
                    <button className="inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-orange-600 hover:bg-orange-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-orange-500" onClick={() => updateCandidateStatus(selectedCandidate.id, 'KIV')} data-id="element-116">
                      <Clock size={16} className="mr-2" data-id="element-117" />
                      {t.keepInView}
                    </button>
                    <button className="inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500" onClick={() => updateCandidateStatus(selectedCandidate.id, 'Rejected')} data-id="element-118">
                      <X size={16} className="mr-2" data-id="element-119" />
                      {t.reject}
                    </button>
                    <button className="inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-green-600 hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500" onClick={() => updateCandidateStatus(selectedCandidate.id, 'Accepted')} data-id="element-120">
                      <Check size={16} className="mr-2" data-id="element-121" />
                      {t.accept}
                    </button>
                    <button className="inline-flex items-center px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500" onClick={() => setShowEmailModal(true)} data-id="element-122">
                      <Send size={16} className="mr-2" data-id="element-123" />
                      {t.sendEmail}
                    </button>
                  </div>
                </div>
              </div> : <div className="h-full flex items-center justify-center" data-id="element-124">
                <div className="text-center p-6" data-id="element-125">
                  <User size={48} className="mx-auto text-gray-400" data-id="element-126" />
                  <h3 className="mt-2 text-sm font-medium text-gray-900" data-id="element-127">
                    {t.noCandidate}
                  </h3>
                </div>
              </div>}
          </div>
        </div>
      </div>
      {/* Email Modal */}
      {showEmailModal && <div className="fixed inset-0 bg-gray-500 bg-opacity-75 flex items-center justify-center z-50" data-id="element-128">
          <div className="bg-white rounded-lg shadow-xl max-w-md w-full p-6" data-id="element-129">
            <h3 className="text-lg font-medium text-gray-900 mb-4" data-id="element-130">
              {t.sendEmail} - {selectedCandidate.name}
            </h3>
            <div className="space-y-4" data-id="element-131">
              <div data-id="element-132">
                <label htmlFor="subject" className="block text-sm font-medium text-gray-700" data-id="element-133">
                  {t.subject}
                </label>
                <input type="text" id="subject" className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm" value={emailSubject} onChange={e => setEmailSubject(e.target.value)} data-id="element-134" />
              </div>
              <div data-id="element-135">
                <label htmlFor="message" className="block text-sm font-medium text-gray-700" data-id="element-136">
                  {t.message}
                </label>
                <textarea id="message" rows={6} className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm" value={emailMessage} onChange={e => setEmailMessage(e.target.value)} data-id="element-137" />
              </div>
              <div className="flex justify-end space-x-3" data-id="element-138">
                <button type="button" className="inline-flex items-center px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500" onClick={() => setShowEmailModal(false)} data-id="element-139">
                  {t.cancel}
                </button>
                <button type="button" className="inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500" onClick={sendEmail} disabled={!emailSubject.trim() || !emailMessage.trim()} data-id="element-140">
                  <Send size={16} className="mr-2" data-id="element-141" />
                  {t.send}
                </button>
              </div>
            </div>
          </div>
        </div>}
      {/* Notification */}
      {notification && <div className="fixed bottom-4 right-4 bg-white rounded-lg shadow-lg p-4 flex items-center z-50" data-id="element-142">
          {notification.type === 'success' ? <Check size={20} className="text-green-500 mr-2" data-id="element-143" /> : <AlertCircle size={20} className="text-red-500 mr-2" data-id="element-144" />}
          <span className="text-gray-800" data-id="element-145">{notification.message}</span>
        </div>}
    </div>;
}